import type { SVGProps } from 'react';

/** Side view of a car, the design's placeholder for a vehicle without photos. */
export function IconCarProfile(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 64 40"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.4}
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M5 27h54M9 27v5M55 27v5M8 27l4-12a5 5 0 0 1 4.7-3.4h30.6A5 5 0 0 1 52 15l4 12" />
            <circle cx="18" cy="27" r="4.5" />
            <circle cx="46" cy="27" r="4.5" />
        </svg>
    );
}
